import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { ChangeDetectionStrategy, Component, Input, OnInit, QueryList, ViewChildren } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { IPageInfo } from "../../pdf-viewer.service";
import { PdfDocumentViewportService } from "./pdf-document-viewport.service";


@Component({
  selector: 'ss-pdf-document-viewport',
  templateUrl: './pdf-document-viewport.component.html',
  styleUrls: ['./pdf-document-viewport.component.css'],
  providers: [
    PdfDocumentViewportService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfDocumentViewportComponent implements OnInit {

  private readonly _destroy = new Subject<void>();

  @ViewChildren(CdkVirtualScrollViewport)
  viewportQueryListProxy!: QueryList<CdkVirtualScrollViewport>



  readonly virtualViewportSubject = this._pdfDocumentViewportService.virtualViewportSubject;
  readonly docPageProxiesObs = this._pdfDocumentViewportService.docPageProxiesObs;

  readonly pdfDocumentSubject = this._pdfDocumentViewportService.pdfDocumentSubject;
  @Input() get pdfDocument() {
    return this.pdfDocumentSubject.value
  }
  set pdfDocument(value) {
    this.pdfDocumentSubject.next(value)
  }

  constructor(
    private _pdfDocumentViewportService: PdfDocumentViewportService
  ) {

  }




  ngOnInit(): void {

  }

  trackByIdx(idx: number, pageInfo: IPageInfo) {
    return pageInfo.realPageIdx + pageInfo.docId;
  }

  ngAfterViewInit() {

    this.viewportQueryListProxy
      .changes
      .pipe(takeUntil(this._destroy))
      .subscribe((change: QueryList<CdkVirtualScrollViewport>) => {
        this.virtualViewportSubject.next(change.first)
      })

  }

  ngOnDestroy() {

    this._destroy.next();
    this._destroy.complete();

  }
}
